import { Component } from '@angular/core';
import {AlertController, App, IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {UserStateProvider} from "../../providers/user-state/user-state";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {ApiAuthProvider} from "../../providers/api-auth/api-auth";
import {InitHelloPage} from "../init-hello/init-hello";
import {IntroWelcomePage} from "../intro-welcome/intro-welcome";
import {AppPasswordChangePage} from "../app-password-change/app-password-change";
import {AppStepCounterPage} from "../app-step-counter/app-step-counter";
import {AppMoodTrackerPage} from "../app-mood-tracker/app-mood-tracker";
import {AppAccountRemovalPage} from "../app-account-removal/app-account-removal";
import {ApiUserProgressProvider} from "../../providers/api-user-progress/api-user-progress";
import {SettingsPopoverDirective} from "../../directives/settings-popover/settings-popover";
import {AppSettingsTrainingPage} from "../app-settings-training/app-settings-training";
import {AppSettingsGoalPage} from "../app-settings-goal/app-settings-goal";
import {ApiProvider} from "../../providers/api/api";
import {AppPausePage} from "../app-pause/app-pause";

/**
 * Generated class for the SettingsPopoverPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-settings-popover',
  templateUrl: 'settings-popover.html',
})
export class SettingsPopoverPage {

  passwordChangePage: any = AppPasswordChangePage;
  stepCounterPage: any = AppStepCounterPage;
  moodTrackerPage: any = AppMoodTrackerPage;
  accountRemovalPage: any = AppAccountRemovalPage;
  settingsTrainingPage: any = AppSettingsTrainingPage;
  settingsActivityGoalPage: any = AppSettingsGoalPage;
  pausePage: any = AppPausePage;
  userName: string = '';
  appVersion: string = 'version'

  constructor(public navCtrl: NavController, public navParams: NavParams, public state: UserStateProvider, public contentTranslation: ContentTranslationProvider, public alertCtrl: AlertController, public apiAuth: ApiAuthProvider, public progress: ApiUserProgressProvider, public loadingCtrl: LoadingController, public app: App, public api: ApiProvider) {
    let cordova = (window as any).cordova;
    if (cordova) {
      cordova.getAppVersion.getVersionNumber((version) => {
        this.appVersion = version;
      });
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SettingsPopoverPage');

    this.userName = this.state.user?this.state.user.firstName:'';
  }

  openPage(page) {
    this.app.getRootNav().push(page);
    this.closePopover();
  }

  logout() {
    var me = this;
    this.closePopover();
    let loader = this.loadingCtrl.create();
    loader.present();
    this.apiAuth.logout().then(res => {
      me.navCtrl.remove(0, 100).then(() => {
      });
      window.location.reload();
    });
  }

  showTerms(prefix) {
    const alert = this.alertCtrl.create({
      title: this.contentTranslation.translateContent(prefix+' title'),
      subTitle: this.contentTranslation.translateContent(prefix+' content'),
      buttons: [
        {
          text: 'OK',
        },
        {
          text: '×',
          cssClass: 'close-button'
        }

      ],
      cssClass: 'ip-alert ip-with-close'
    });
    alert.present();
  }

  updateProgress() {
    this.progress.triggerProgressUpdate().then(() => {
      window.location.reload();
    })
  }

  showPdf() {
    window.open(this.contentTranslation.translateContent('PDF Diga URL'), '_system', 'location=yes');
    // window.open('https://videamellitus.de/wp-content/uploads/2022/08/Gebrauchsanweisung-fuer-die-DiGA-Videa-mellitus_4.0.pdf', '_system', 'location=yes'); return false;
  }

  updateName() {
    this.state.user.firstName = this.userName;
    this.api.callPut('/users/'+this.state.user.id, {firstName: this.userName}).subscribe((res:any) => {
    })

  }

  closePopover() {
    if(this.navParams.get('popoverObject')) {
      this.navParams.get('popoverObject').dismissPopup();
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings-popover/settings-popover.ts